__turbopack_context__.v({
  "container": "VIYlsW_container",
});
